import type { PositionInstructions } from "@coolset/cs-ui";
import { SurveyBlocks } from "modules/MainSurveyEditor/surveyBlocks";

export const getBlocksInRows = (
  rowPositions: number[],
  blocks: SurveyBlocks.Block[],
  positionInstructions: PositionInstructions,
): SurveyBlocks.Block[] => {
  const rows = new Set(rowPositions);
  return blocks.filter((b) => {
    const rowStart = positionInstructions[String(b.id)]?.rowStart;
    return rowStart !== undefined && rows.has(rowStart);
  });
};
